import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SharedService } from '../services';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private sharedService: SharedService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // const url: string = state.url;
        return this.checkLogin();
    }

    checkLogin(): boolean {
        if (sessionStorage.getItem('bearer-token')) {
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}
